<div class="phase-header" *ngIf="headerKpis$ | async as headerKpis">
  <div class="dynamic-grid">
    <lib-speed-monitor [mode]="screenMode" [workCenterId]="workCenterId" [style]="{ width: '240px' }"></lib-speed-monitor>

    <div class="deviation" *ngIf="showInactive">
      <span class="deviation__label">{{ 'PHASE_HEADER.DEVIATION_FROM_PLAN' | translate }}</span>
      <span class="deviation__value">{{ headerKpis.deviationFromPlan | elapsedTime }}</span>
    </div>

    <div class="quantity">
      <span class="quantity__label">{{ 'PHASE_HEADER.GOOD_QUANTITY' | translate }}</span>
      <span class="quantity__value">{{ headerKpis.goodQuantity | formatQuantity : false }}</span>
    </div>

    <app-sampling-kpi
      *ngIf="isSamplingEnabled"
      [totalAqlSampleQuantity]="headerKpis.totalAqlSampleQuantity"
      [totalTgsSampleQuantity]="headerKpis.totalTgsSampleQuantity"
    ></app-sampling-kpi>

    <app-header-waste-display [waste]="headerKpis.waste" [maculature]="headerKpis.maculature"></app-header-waste-display>

    <div class="quantity">
      <span class="quantity__label">{{ 'PHASE_HEADER.REMAINING_QUANTITY' | translate }}</span>
      <span
        class="quantity__value"
        *ngIf="headerKpis.remainingQuantity.value; else noRemainingQuantity"
        [ngClass]="{ 'quantity__value--negative': headerKpis.remainingQuantity.value < 0 }"
      >
        {{ headerKpis.remainingQuantity | formatQuantity : false }}
      </span>
      <ng-template #noRemainingQuantity>
        <span class="quantity__value">0</span>
      </ng-template>
    </div>
  </div>
</div>
